// supabase-js's FunctionsHttpError only exposes a generic message ("Edge Function returned a
// non-2xx status code") on error.message — the real { error: "..." } body is on error.context
// (the raw Response). Read that for the actual, useful message.
export async function extractFunctionErrorMessage(error, fallback = "Edge Function error") {
  try {
    if (error?.context?.json) {
      const body = await error.context.clone().json();
      if (body?.error) return body.error;
    }
  } catch {
    // fall through to generic message below
  }
  return error?.message ?? fallback;
}
